import axios from "axios";
import {
  addScholarshipStart,
  addScholarshipSuccess,
  addScholarshipFailure,
  updateScholarshipStart,
  updateScholarshipSuccess,
  updateScholarshipFailure,
  fetchScholarshipStart,
  fetchScholarshipSuccess,
  fetchScholarshipFailure,
  deleteScholarshipStart,
  deleteScholarshipSuccess,
  deleteScholarshipFailure,
} from "../slicer/scholarshipSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const fetchScholarships = () => async (dispatch) => {
  dispatch(fetchScholarshipStart());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/scholarship`,
      getAuthHeaders()
    );
    const data = Array.isArray(response.data.data) ? response.data.data : [];
    dispatch(fetchScholarshipSuccess(data));
  } catch (error) {
    dispatch(
      fetchScholarshipFailure(
        error.response?.data?.message || "Failed to fetch scholarships"
      )
    );
  }
};

export const addScholarship = (scholarshipInfo) => async (dispatch) => {
  dispatch(addScholarshipStart());
  try {
    const token = getToken();
    const headers = { "Content-Type": "multipart/form-data" };
    if (token) headers["Authorization"] = `Bearer ${token}`;

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/scholarship`,
      scholarshipInfo,
      { headers }
    );

    if (response.data?.success) {
      dispatch(addScholarshipSuccess(response.data.data));
    } else {
      throw new Error(response.data?.message || "Failed to add scholarship");
    }
  } catch (error) {
    dispatch(
      addScholarshipFailure(
        error.response?.data?.message || "Failed to add scholarship"
      )
    );
    throw error;
  }
};

export const updateScholarship = (id, payload) => async (dispatch) => {
  dispatch(updateScholarshipStart());
  try {
    const token = getToken();
    const headers = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;

    const response = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/scholarship/${id}`,
      payload,
      { headers }
    );

    dispatch(updateScholarshipSuccess(response.data.data));
    return response.data;
  } catch (error) {
    dispatch(
      updateScholarshipFailure(
        error.response?.data?.message || "Failed to update scholarship"
      )
    );
    throw error;
  }
};

export const deleteScholarship = (id) => async (dispatch) => {
  dispatch(deleteScholarshipStart());
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/scholarship/${id}`,
      getAuthHeaders()
    );

    if (response.data.success) {
      dispatch(deleteScholarshipSuccess(id));
    } else {
      throw new Error(response.data.message || "Failed to delete scholarship");
    }
  } catch (error) {
    dispatch(
      deleteScholarshipFailure(
        error.response?.data?.message || "Failed to delete scholarship"
      )
    );
    throw error;
  }
};
